module.exports = __webpack_public_path__ + "static/genify-logo-main-628de03e81016c3d011becf371b0e425.webp";